module.exports = __webpack_public_path__ + "img/calendar-check.f4c918df.svg";